export { default } from './JapanMMViewFAQ'
